import { useEffect, useState } from "react";
import { PageHeader, Empty } from "@/components/UIBits";
import api from "@/lib/api";
import { Download } from "lucide-react";

export default function VCards() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try {
      setRows(await api.listVcards());
    } catch {/* ignore */}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="vcards-page">
      <PageHeader
        title="vCards"
        subtitle={`// ${rows.length} generated`}
        testid="vcards-header"
      />

      {rows.length === 0 ? (
        <Empty testid="vcards-empty">No vCards generated yet</Empty>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {rows.map((v) => (
            <div
              key={v.id}
              data-testid={`vcard-card-${v.id}`}
              className="border border-[#1f1f23] bg-[#0e0e10] p-5"
            >
              <p className="font-heading text-lg text-white">{v.name}</p>
              <div className="mt-3 space-y-1">
                <p className="font-mono text-xs text-zinc-500">
                  STRANGER · <span className="text-blue-400">{v.stranger_number}</span>
                </p>
                <p className="font-mono text-xs text-zinc-500">
                  SHADOW · <span className="text-amber-400">{v.shadow_number}</span>
                </p>
                <p className="font-mono text-xs text-zinc-500">
                  FOR USER · {v.user_real_number}
                </p>
              </div>
              <pre className="mt-3 font-mono text-[10px] text-zinc-500 bg-black border border-[#1f1f23] p-2 max-h-[120px] overflow-auto">
                {v.vcf}
              </pre>
              <a
                href={api.vcardFileUrl(v.id)}
                target="_blank"
                rel="noreferrer"
                data-testid={`vcard-download-${v.id}`}
                className="inline-flex items-center gap-2 mt-3 font-mono text-xs text-zinc-400 hover:text-white"
              >
                <Download className="w-3 h-3" /> download .vcf
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
